import { render, staticRenderFns } from "./boxTitle.vue?vue&type=template&id=d2b217f4&scoped=true"
import script from "./boxTitle.vue?vue&type=script&lang=js"
export * from "./boxTitle.vue?vue&type=script&lang=js"
import style0 from "./boxTitle.vue?vue&type=style&index=0&id=d2b217f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b217f4",
  null
  
)

export default component.exports